import http from "../http-common";

const upload = (codigo, index, file, onUploadProgress) => {
    let formData = new FormData();
    formData.append(`files`, file);
    let indexFile =parseInt(index) + 1;
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
        },
    };
    let url = "/fileUpload?codigo="+codigo+"&index="+indexFile;
    //return http.post(url, formData, config).then(onUploadProgress);
    return fetch(url, {
        method: 'POST',
        body: formData,
    }).then(onUploadProgress);
};

const getFiles = (codigo) => {
    //return http.get("/images?codigo="+codigo);
    return fetch("/images?codigo="+codigo);
};

const FileUploadService = {
    upload,
    getFiles,
};

export default FileUploadService;